import { BucketId, FileReferenceId } from '@kaizenplatform/belfast-entity';
import { createElement, FC, useContext } from 'react';

import BatchDownload from '../component/compound/AssetCategoryDetail/BatchDownload';
import { context as DependencyContext } from '../context/dependency';

type Props = {
  bucketId?: BucketId;
  fileIds?: ReadonlyArray<FileReferenceId>;
};

export const EnhancedBatchDownload: FC<Props> = ({ bucketId, fileIds }) => {
  const dependency = useContext(DependencyContext);
  const download = async ({ bucketId, fileIds }: { bucketId?: BucketId; fileIds?: ReadonlyArray<FileReferenceId> }) => {
    if (bucketId != null) {
      await dependency.showProjectUsecase.downloadAssets({
        buckets: [bucketId],
        files: [],
        projects: [],
      });
    } else if (fileIds != null) {
      await dependency.showProjectUsecase.downloadAssets({
        buckets: [],
        files: fileIds,
        projects: [],
      });
    }
  };

  return <BatchDownload bucketId={bucketId} fileIds={fileIds} onClickBatchDownloadButton={download} />;
};
